import React from 'react';
import { Helmet } from "react-helmet";

class RedirectApp extends React.Component {
  render() {
    const url = this.props.location.search.split('?redirect_url=');
    const getPostId = url[1].lastIndexOf('/');
    const postId =  url[1].substring(getPostId  + 1).split('&')[0];
    const getType = this.props.location.search.split('&type=');
    let appUrl;

    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      appUrl = `com.thetansorb.roomerresume.RoomerResume://postid=${postId}&type=${getType[1]}`;
    } else {
      // appUrl = `intent://?ret=http://13.56.79.65:3000?postid=${postId}&type=${getType[1]};scheme=http;package=com.roomer_resume;S.browser_fallback_url=http://13.56.79.65:3000;end`;
      appUrl = `market://details?id=com.roomer_resume&postid=${postId}&type=${getType[1]}`;
      // appUrl = `market://details?id=com.buymysneakers`;
      // appUrl = `market://details?id=com.roomer_resume&url=com.roomer_resume?postid=${postId}&type=${getType[1]}`;
      // appUrl = `intent://whatever/#Intent;scheme=http;package=com.roomer_resume;S.postid=${postId};end`;
    }

    return (
      <React.Fragment>
        <Helmet>
          <meta property="al:ios:url" content="https://itunes.apple.com/us/app/roomresume/id1151619605?ls=1&mt=8" />
          <meta property="al:ios:app_store_id" content="1392857337" />
          <meta property="al:ios:app_name" content="roomresume" />
          <meta property="og:title" content="roomresume" />
          <meta property="al:android:url" content={`${appUrl}`} />

          <meta property="al:android:ss" content="roomresume" />
          <meta property="og:title" content="roomresume" />
          <meta property="og:type" content="roomresume" />

          <script type="text/javascript">{
            (function () {
              // var uagent = navigator.userAgent.toLowerCase();
              // console.log('uagent', uagent);
              var app = {
                launchApp: function () {
                  window.parent.location.href = appUrl;
                  setTimeout(this.openWebApp, 5000);
                },
                openWebApp: function () {
                  window.parent.location.href = url[1];
                }
              };
              setTimeout(app.launchApp(), 100);
            })()
          }</script>
        </Helmet>
        <header className="menu_logo back">
          <div className="left_logo">
            <img alt="" src="/images/logo.png" />
          </div>
          <div className="right_logo">
          </div>
        </header>
        <div className="container">
        <section className="menu_list">
          <h3>We are redirecting to WebApp, Please be patient ....</h3>
        </section>
        </div>
      </React.Fragment>
    )
  }
}


export default (RedirectApp);